<template>
  <div ref="product_component">
    <slot name="product" v-bind="this"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedId: null,
      price: '$0.00',
      compare: '$0.00',
      current_variant: null,
      current_variant_index: 0,
      variants_images: {},
      checkVariant: {},
      parentQty: 1,
      stickSlider: false,
      inStock: null,
      product_name: null
    }
  },
  props: {
    product: null,
    checkVariants: '',
    firstVariant: null,
    firstQuantity: null,
    variants_product: null
  },
  methods: {
    onSwiper(){
      this.$parent.onSwiper();
    },
    changeSlide(){
      this.$parent.changeSlide(this.current_variant_index);
    },
    handleScroll(){
      this.stickSlider = window.scrollY > document.querySelector(".main_product").offsetTop && window.innerWidth > 767 && document.querySelector("body").clientHeight > 800;
    },
    isSticked(){
      return this.stickSlider ? "swiper-container--sticky" : "";
    },
    isSelected(radioId){
      return radioId === this.selectedId ? 'product-option__option--selected' : '';
    },
    formatMoney(cents){
      const precision = 2;
      const thousands = ',';
      const decimal   = '.';

      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      if (isNaN(cents) || cents == null) { return 0; }

      cents = (cents/100.0).toFixed(precision);

      var parts   = cents.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return "$"+dollars + cents;
    },
    variant(radioId, stock) {
      this.inStock = stock;

      this.getNameProduct(radioId);

      if (this.selectedId == radioId) {
        this.checkVariant[radioId] = true;
      } else {
        this.checkVariant[radioId] = false;
      }

      const prod = JSON.parse(this.product);
      prod.variants.forEach((variant, index) => {
        if (variant.id === radioId) {
          this.current_variant = variant;
          this.current_variant_index = index+1;
        }
      });
      this.changeSlide();
      
      this.price = this.formatMoney(this.current_variant.price);
      this.compare = this.current_variant.compare_at_price ? this.formatMoney(this.current_variant.compare_at_price) : '$0.00';

      let params = location.search.replace('?', '').split('&');
      let new_params = [];
      params.forEach(val => {
        let val_obj = val.split('=');
        val_obj[1] = val_obj[0] == "variant" ? radioId : val_obj[1];
        new_params.push(val_obj.join('='));
      });
      new_params = new_params.length < 3 ? `variant=${radioId}` : new_params;
      new_params = `?${new_params}`;
      this.selectedId = radioId;
      const new_url = window.location.origin + window.location.pathname + new_params;
      history.pushState(null, "", new_url);

      this.parentQty = 1;
    },
    plusQty() {
      this.parentQty++;
    },
    minusQty() {
      this.parentQty--;
    },
    submitProd(e) {
      e.preventDefault();

      let formData = {
        'items': [{
          'id': this.current_variant.id,
          'quantity': this.parentQty
        }]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.replace(window.location.origin + '/cart')
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    getNameProduct(radioId) {
      let variants = JSON.parse(this.variants_product)

      variants.forEach(variant => {
        if(variant.id === radioId) {
          this.product_name = variant.name;

        }
      });
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted(){
    this.checkVariant = JSON.parse(this.checkVariants);
    this.current_variant = JSON.parse(this.firstVariant);
    this.selectedId = this.current_variant.id;
    const prod = JSON.parse(this.product);
    prod.variants.forEach(variant => {
      this.variants_images[variant.id] = variant.featured_image.src;
    });
    this.variant(this.current_variant.id);
    this.getNameProduct(this.selectedId);
    this.inStock = this.firstQuantity;
    this.input1?this.input1.value = this.inStock : null;
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
